import React from 'react';

const TicketsTab = () => {
  return (
    <div>
      <h2>Tickets Management</h2>
      {/* Add ticket management content */}
    </div>
  );
};

export default TicketsTab; 